module.exports = __webpack_public_path__ + "media/images/cleaning/pro1-a9cbce0445a049925b47eb8e7de39331.jpg";